/*
  Plank card links
  ----------------
  Product cards link to the clean, canonical product URL (/products/<handle>)
  so crawlers credit one URL per product. The variant the card displayed is
  only appended (?variant=) at the moment a shopper interacts with the link,
  so they still land on the same variant they saw. Covers click, keyboard,
  middle-click, and right-click / open-in-new-tab.

  Also records which collection the shopper came from, so the product page
  breadcrumb can show it (see sections/breadcrumbs.liquid).

  Loaded as a module from snippets/card-product.liquid; module scripts with the
  same URL execute once per page however many cards render.
*/
(function () {
  if (window.__plankCardLinks) return;
  window.__plankCardLinks = true;

  var CRUMB_KEY = 'plank:crumb';

  function prepare(link) {
    var card = link.closest('[data-card-product]');
    if (!card) return;

    var variant = card.getAttribute('data-card-variant');
    if (variant && link.getAttribute('data-card-variant-applied') !== variant) {
      try {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        url.searchParams.set('variant', variant);
        link.setAttribute('href', url.pathname + url.search + url.hash);
        link.setAttribute('data-card-variant-applied', variant);
      } catch (e) {}
    }

    var collectionUrl = card.getAttribute('data-card-collection-url');
    if (collectionUrl) {
      try {
        localStorage.setItem(
          CRUMB_KEY,
          JSON.stringify({
            h: card.getAttribute('data-card-product'),
            u: collectionUrl,
            t: card.getAttribute('data-card-collection-title') || '',
            ts: Date.now()
          })
        );
      } catch (e) {}
    }
  }

  function handler(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var link = target.closest('a[data-card-link]');
    if (link) prepare(link);
  }

  ['pointerdown', 'click', 'auxclick', 'contextmenu', 'keydown'].forEach(function (type) {
    document.addEventListener(type, handler, true);
  });
})();
